var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VGridRow',{class:{
        'grid-row_aling-center': true,
        'grid-row_justify-end': _vm.isReverse,
    }},[_c('div',_vm._g({staticClass:"button-back"},_vm.$listeners),[_c('KeyboardBackspaceSVG',{class:{ 'button-back_reverse': _vm.isReverse }}),_c('div',{staticClass:"button-back__title"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }